module.exports = __webpack_public_path__ + "img/type20021.5dc12ad5.png";